<template>
    <label v-if="!$attrs.id" :for="getId" :class="{'sr-only' : !showLabel}" class="block text-sm font-medium text-bhav-cool-gray-600">{{ label }}</label>
    <p class="bg-bhav-cool-gray-50 sm:text-sm w-full rounded-md inline-flex text-bhav-blue-500" :class="$attrs.class">
        <span v-if="prefixIcon" :class="prefixIcon" class="absolute px-2 py-3 text-bhav-blue-500"></span>
        <input :id="getId" class="bg-transparent rounded-md w-full placeholder:text-bhav-blue-200 px-2 py-3" :class="{'pl-7' : prefixIcon}" v-bind="{...$attrs, class: undefined}" :type="type" :maxlength="maxLength" v-model="value" />
    </p>
</template>

<script>
export default {
    emits: [
        'update:modelValue'
    ],
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        getId() {
            return this.$attrs.id || `field-${this.$.uid}`;
        }
    },
    props: {
        modelValue: {
            required: true
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
        },
        type: {
            type: String,
            default: 'text'
        },
        prefixIcon: {
            type: String,
            default: null
        },
        maxLength: {
            type: Number,
            default: null
        }
    }
}
</script>
